<template>
  <main-rent :header="header" :first-available="firstAvailable">
    <size :rent-type="'subscription'" />
    <delivery :rent-type="'subscription'" />
    <rent-period :rent-type="'subscription'" />
    <payment :rent-type="'subscription'" @updateSubscription="changeSubscription" />
  </main-rent>
</template>

<script>
import MainRent from './MainRent.vue'
import { Size, Delivery, RentPeriod, Payment } from 'theme/components/core/blocks/Product-v2/Rent/components'
import { mapGetters } from 'vuex'

export default {
  name: 'SubscriptionRent',
  components: {
    MainRent,
    Size,
    Delivery,
    RentPeriod,
    Payment
  },
  props: {
    firstAvailable: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      headerPrice: '',
      subscriptionName: '',
      itemsToRent: 2
    }
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct',
      getUserSubscription: 'user/getSubscriptions'
    }),
    header () {
      return {
        mainTitle: this.mainTitle,
        subtitle: this.subtitle,
        price: this.price,
        subscriptionName: this.subscriptionName,
        activeSubscription: this.activeSubscription
      }
    },
    activeSubscription () {
      return this.getUserSubscription[0] && this.getUserSubscription[0].subscription_name
    },
    mainTitle () {
      return 'With membership'
    },
    subtitle () {
      return this.activeSubscription ? `${this.$t('Your active subscription')} - ${this.activeSubscription}` : `${this.itemsToRent} ${this.$t('items per month')}`
    },
    price () {
      return this.activeSubscription ? 0 : this.headerPrice || 299
    }
  },
  mounted () {
    this.$bus.$on('user-after-loggedin', this.resetSelectedSubscription)
  },
  methods: {
    resetSelectedSubscription () {
      this.subscriptionName = ''
    },
    changeSubscription (value) {
      this.subscriptionName = value.name
      this.itemsToRent = value.points
      this.headerPrice = this.parseDesc(value.description)
    },
    parseDesc (desc) {
      if (desc) {
        // walkaround because of different data format in magento
        desc = desc.replace(',', '.')
        let idxStart = desc.indexOf('>')
        let idxEnd = desc.indexOf('.')
        let result = desc.slice(idxStart + 1, idxEnd + 1)
        if (!result) {
          idxStart = desc.indexOf('>')
          idxEnd = desc.indexOf('</')
          return desc.slice(idxStart + 1, idxEnd)
        }
        return result
      } else {
        return ''
      }
    }
  }
}
</script>
